module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.filterUsers
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addUserClick()
      }
    }
  }, [_vm._v("+ Add User")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addExistingUserClick()
      }
    }
  }, [_vm._v("+ Add Existing User")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "User Email",
      "min-width": 25,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "Role",
      "sortable": "",
      "min-width": 25
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "min-width": 25
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.userDeleteClick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Remove Access\n                        to Zone")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.userDeleteDialog.title,
      "visible": _vm.userDeleteDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.userDeleteDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userDeleteDialog.loading),
      expression: "userDeleteDialog.loading"
    }],
    attrs: {
      "model": _vm.userDeleteDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.userDeleteDialog.form.email),
      callback: function($$v) {
        _vm.$set(_vm.userDeleteDialog.form, "email", $$v)
      },
      expression: "userDeleteDialog.form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.userDeleteDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.userDeleteDialogClick()
      }
    }
  }, [_vm._v("Remove\n                    Access")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.addUserDialog.title,
      "visible": _vm.addUserDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.addUserDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.addUserDialog.loading),
      expression: "addUserDialog.loading"
    }],
    attrs: {
      "model": _vm.addUserDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.addUserDialog.form.email),
      callback: function($$v) {
        _vm.$set(_vm.addUserDialog.form, "email", $$v)
      },
      expression: "addUserDialog.form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.addUserDialog.form.password),
      callback: function($$v) {
        _vm.$set(_vm.addUserDialog.form, "password", $$v)
      },
      expression: "addUserDialog.form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "please select user role"
    },
    model: {
      value: (_vm.addUserDialog.form.role),
      callback: function($$v) {
        _vm.$set(_vm.addUserDialog.form, "role", $$v)
      },
      expression: "addUserDialog.form.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Building Admin",
      "value": "buildingAdmin"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Building Admin Advanced",
      "value": "buildingAdminAdvanced"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addUserDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addUserDialogClick()
      }
    }
  }, [_vm._v("Add User")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.addExistingUserDialog.title,
      "visible": _vm.addExistingUserDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.addExistingUserDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.addExistingUserDialog.loading),
      expression: "addExistingUserDialog.loading"
    }],
    attrs: {
      "model": _vm.addExistingUserDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "margin-bottom": "30px",
      "width": "350px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "clearable": "",
      "placeholder": "Please Input"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.addExistingUserDialog.form.email),
      callback: function($$v) {
        _vm.$set(_vm.addExistingUserDialog.form, "email", $$v)
      },
      expression: "addExistingUserDialog.form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addExistingUserDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addExistingUserDialogClick()
      }
    }
  }, [_vm._v("Add Access To\n                    Zone")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b7394e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ZoneUsers.vue
// module id = 1403
// module chunks = 1